import { StoreLocatorHours } from '@/components/content/StoreLocator/components/StoreLocatorDetails/StoreLocatorHours';
import { StoreLocatorShowInMap } from '@/components/content/StoreLocator/components/StoreLocatorDetails/StoreLocatorShowInMap';
import { StoreLocatorComplementaryData } from '@/components/content/StoreLocator/components/StoreLocatorList/StoreLocatorComplementaryData';
import { StoreLocatorMoreInfo } from '@/components/content/StoreLocator/components/StoreLocatorList/StoreLocatorMoreInfo';
import { StoreLocatorStatus } from '@/components/content/StoreLocator/components/StoreLocatorList/StoreLocatorStatus';
import {
	storeLocatorDetailsContainerSX,
	storeLocatorDetailsGoBackSX,
	storeLocatorDetailsSX,
} from '@/components/content/StoreLocator/styles/StoreLocatorDetails/storeLocatorDetailsStyles';
import stateCitiesData from '@/data/Content/StoreLocator/storeLocatorStateCitiesList.json';
import { useLocalization } from '@/data/Localization';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { Divider } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FC, useMemo } from 'react';
import { StoreData } from 'shared/custom/types/commonTypes';

export const StoreLocatorDetails: FC<{
	selectedState: string;
	stLocId: string;
	onHandleMoreInfo: (stLocId: string) => void;
}> = ({ selectedState, stLocId, onHandleMoreInfo }) => {
	const cityList = stateCitiesData.formScheduleObject;
	const localization = useLocalization('StoreLocator');
	const storeData = useMemo(() => {
		const listOfStores = cityList.filter((stores) => stores.stateId === selectedState)[0];
		return listOfStores.stores.find((store) => store.stLocId === stLocId);
	}, [cityList, selectedState, stLocId]) as StoreData;

	return (
		<Box sx={storeLocatorDetailsSX}>
			<Typography
				variant="body1"
				fontSize={14}
				sx={storeLocatorDetailsGoBackSX}
				onClick={() => onHandleMoreInfo('')}
			>
				<KeyboardArrowLeft viewBox="0 0 20 24" />
				{localization.goBackStore.t()}
			</Typography>
			<Box sx={storeLocatorDetailsContainerSX}>
				<Typography variant="h6">{`${storeData?.storeName} #${storeData?.stLocId}`}</Typography>
				<StoreLocatorStatus storeData={storeData} />
				<StoreLocatorComplementaryData storeData={storeData} />
				<StoreLocatorHours scheduleData={storeData.scheduleDiystore.schedule} />
				<StoreLocatorMoreInfo phone={storeData.phone} showMoreInfo={false} />
			</Box>
			<Divider />
		</Box>
	);
};
